import React, { useEffect } from 'react'
import './App.css'
import { Routes } from './routes'
import 'antd/dist/antd.css'
import { useLocation } from 'react-router'
import dayjs from 'dayjs'
import 'dayjs/locale/th'
dayjs.locale('th')

export const App: React.FC<{ id: string }> = () => {
  const { pathname } = useLocation()
  useEffect(() => {
    document.getElementById('contentBody')?.scrollTo(0, 0)
  }, [pathname])

  return <Routes />
}
